export const isProfileType = (type?: string[]): boolean => !!(type && type.includes('Profile'));
